import { graphql as gql } from "@/generated";
import { useMutation } from "@urql/vue";

const AuthenticateDocument = gql(/* GraphQL */ `
  mutation Authenticate(
    $channelId: String!
    $authChannel: AuthChannelType!
    $request: InitiateAuthenticationRequest!
    $options: GenericAuthenticationOptionsInput
  ) {
    authenticate(
      channel_id: $channelId
      auth_channel: $authChannel
      request: $request
      options: $options
    ) {
      ... on AuthenticationResponse {
        code
        state
        countdown_milliseconds
      }
      ... on InvalidInitiateAuthRequestError {
        error
        message
      }
      ... on RateLimitedPhoneNumberError {
        error
        phone_number
        countdown_milliseconds
      }
    }
  }
`);

const VerifyAuthenticationDocument = gql(/* GraphQL */ `
  mutation VerifyAuthentication(
    $channelId: String!
    $authChannel: AuthChannelType!
    $request: ValidateAuthenticationRequest!
    $options: GenericAuthenticationOptionsInput
  ) {
    verifyAuthentication(
      channel_id: $channelId
      auth_channel: $authChannel
      request: $request
      options: $options
    ) {
      ... on SessionResponse {
        user {
          ...UserStoreMe
        }
        validated_identifiers {
          type
          value
          confirmation_token
        }
        jwt
        auth_channel
      }
      ... on InvalidAuthCodeError {
        error
        code
        message
      }
    }
  }
`);

export function useAuthentication() {
  const { executeMutation: authenticate } = useMutation(AuthenticateDocument);
  const { executeMutation: verifyAuthentication } = useMutation(
    VerifyAuthenticationDocument,
  );

  return {
    authenticate,
    verifyAuthentication,
  };
}
